// Base origin of the cheesta-api backend (no trailing slash, no /api suffix).
// Used both to build the /api base URL below and to resolve relative
// paths the backend returns for uploaded files (logoUrl, mainImage, etc.),
// e.g. `${API_ORIGIN}${business.logoUrl}`.
//
// Set REACT_APP_API_URL at BUILD time (Create React App inlines
// process.env.REACT_APP_* into the static bundle - it cannot be changed
// after `npm run build`). Falls back to localhost:4000 so local `npm start`
// development keeps working unchanged.
export const API_ORIGIN = (process.env.REACT_APP_API_URL || 'http://localhost:4000').replace(/\/+$/, '');

export const API_URL = `${API_ORIGIN}/api`;
